import script from "./NewUserTip.vue?vue&type=script&lang=ts&setup=true"
export * from "./NewUserTip.vue?vue&type=script&lang=ts&setup=true"

import "./NewUserTip.vue?vue&type=style&index=0&id=a5c2a536&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a5c2a536"]])

export default __exports__